import React from "react";

const ComponentPlaceholder = (props) => {
  const {
    until,
    hideChildren = true,
    transparent = false,
    children,
    className = "",
    style
  } = props;

  return <div
    className={`position-relative ${hideChildren || until ? "" : className}`}
    style={hideChildren || until ? {} : {...style}}
  >
    <div
      className={`
        component-placeholder
        placeholder-background
        full-width
        border-radius-xs
        ${transparent ? "opacity-0" : ""}
        ${hideChildren ? className : "position-absolute"}
      `}
      style={{
        display: until ? "none" : null,
        ...style
      }}
    >
    </div>

    <div style={{display: until || !hideChildren ? null : "none"}}>
      {children}
    </div>
  </div>;
};

export default ComponentPlaceholder;
